import { render } from "./SlidePoiseFilmCover.vue?vue&type=template&id=e2d8b8aa"
const script = {}

import "../../../public/assets/video/slidepoise/cover.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__